import {
  ChangeEvent,
  FocusEvent,
  forwardRef,
  TextareaHTMLAttributes,
  useMemo,
} from "react";
import { withValidate } from "./withValidate";
import { twMerge } from "tailwind-merge";
import { useCallback } from "react";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  regexp?: "date" | "business-number";
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      regexp,
      className,
      onChange,
      inputMode: initialInputMode,
      onBlur,
      rows = 4, // 기본적으로 4줄 크기로 설정
      cols = 20, // 기본적으로 50글자 크기로 설정
      ...props
    },
    ref
  ) => {
    const inputMode = useMemo(() => {
      if (initialInputMode) return initialInputMode;
      return "text";
    }, [initialInputMode]);

    const handleChange = useCallback(
      (event: ChangeEvent<HTMLTextAreaElement>) => {
        const { target } = event;
        const formattedValue = target.value;

        target.value = formattedValue;

        onChange?.(event);
      },
      [onChange, regexp]
    );

    const handleBlur = useCallback(
      (e: FocusEvent<HTMLTextAreaElement>) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        onBlur?.(e);
      },
      [onBlur]
    );

    return (
      <label className={twMerge("flex flex-col", className)}>
        <textarea
          {...props}
          inputMode={inputMode}
          ref={ref}
          rows={rows}
          cols={cols}
          onBlur={handleBlur}
          onChange={handleChange}
          // onPaste={handlePaste}
          className="!resize-none outline-none transition-all p-2.5 border border-inherit rounded disabled:bg-[#E9E9E9] disabled:text-[#666666] focus:outline-yellow"
        />
      </label>
    );
  }
);

export const ValidateTextarea = withValidate(Textarea);
